import React from 'react';

import LnbComponent from './LnbComponent';
import FooterLayoutComponent from '../common/layout/FooterLayoutComponent';

const IntroductionComponent = props => (
    <main className="about">
        <div className="body">
            <div className="head">
                <div className="title">
                    INTRODUCTION
                </div>
                <LnbComponent
                tabIdx={0}
                    {...props}
                />
            </div>
            <section className="intro-t1 l hist">
                <div className="img">
                    <img
                        src="/imgs/aboutTCE_INTRODUCTION_1.png"
                        alt="history &amp; reliability"
                    />
                </div>
                <div className="info">
                    <h3 className="title">HISTORY &amp; RELIABILITY</h3>
                    <div className="divider"></div>
                    <p className="desc">
                        TCE has been making denim over 64 years as
                        one of the oldest denim factories in
                                    Asia.<br />
                        <br />
                                    Our long history has been possible based on
                                    the stable quality and customization, and
                                    the trust from our valuable customers.
                                </p>
                </div>
            </section>
            <section className="intro-t1 r big">
                <div className="info">
                    <h3 className="title">BIG</h3>
                    <div className="divider"></div>
                    <p className="desc">
                        TCE DENIM currently produce 3.5 million
                        yds/month, which is the largest fabric
                                    capacity in Vietnam.<br /><br />
                                    We can make a total of over 1.3 million
                                    pcs/month garments and washing production
                                    capability at both TCE Vina Denim and TCE
                                    Jeans.<br /><br />
                                    Big capacity enables us to manage flexible
                                    lead time control and competitive
                                    manufacturing cost.
                                </p>
                </div>
                <div className="img">
                    <img
                        src="/imgs/aboutTCE_INTRODUCTION_2.png"
                        alt="BIG"
                    />
                </div>
            </section>
            <section className="intro-t1 l simple">
                <div className="img">
                    <img
                        src="/imgs/aboutTCE_INTRODUCTION_3.png"
                        alt="MAKE IT SIMPLE"
                    />
                </div>
                <div className="info">
                    <h3 className="title">MAKE IT SIMPLE</h3>
                    <div className="divider"></div>
                    <p className="desc">
                        We can do everything in one place by
                        vertically integrated full package service
                                    from fabric to garment.<br />
                        <br />
                                    Well organized fabric and garment R&D
                                    cooperation provide you effective sample
                                    work experience at one place and with
                                    simplified process.<br />
                        <br />
                                    Our design function can provide you quick
                                    buying and sourcing processes. <br />
                        <br />
                                    Multiple FTA advantages are available such
                                    as EU-VIETNAM FTA, EAEU-VIETNAM FTA,
                                    JAPAN-VIETNAM FTA, KOREA-VIETNAM FTA, CPTPP
                                    and others. These duty-free benefits enable
                                    you to handle easy import cost and process.
                                    We are available yarn forward stand level
                                    certificate of origin by vertical production
                                    in Vietnam from yarn to garment. <br />
                        <br />
                    </p>
                </div>
            </section>
            <section className="intro-t1 r saving">
                <div className="info">
                    <h3 className="title">SAVING OUR PLANET</h3>
                    <div className="divider"></div>
                    <p className="desc">
                        We focus on eco-friendly production that
                                    will leave a minimal impact on nature.<br />
                        <br />
                                    One stop denim sustainable solution is
                                    available by using our sustainable fabric,
                                    infrastructure and garment production
                                    process<br />
                        <br />
                                    Our factories are ‘No Discharge Factory’ for
                                    next generation to give better
                                    environmental.<br />
                    </p>
                    <dl className="etc">
                        <dt>INFRA-STRUCTURE</dt>
                        <dd>
                            · Wastewater recycling system<br />
                                        · Steam drain recycling system<br />
                                        · Cooling water recycling system<br />
                        </dd>
                    </dl>
                </div>
                <div className="img">
                    <img
                        src="/imgs/aboutTCE_INTRODUCTION_4.png"
                        alt="SAVING OUR PLANET"
                    />
                </div>
            </section>
            <section className="intro-sust">
                <h3>SUSTAINABLE WASHING</h3>
                <div className='img'>
                    <img src='/imgs/aboutTCE_INTRODUCTION_5.png'
                        alt='sustainable washing' />
                </div>
                <div className='img-mb'>
                    <img src='/imgs/mobile-aboutTCE_INTRODUCTION_5.png'
                        alt='sustainable washing' />
                </div>
            </section>
        </div>
        <FooterLayoutComponent
            {...props} />
    </main>
)

export default IntroductionComponent;